import { create } from 'zustand';
import type { StateCreator } from 'zustand';

type statusBarType = 'sparkRun' | 'memoryCreation' | 'sparkRunRecommendations';
type statusBarConfigType = {
  statusBarType?: statusBarType;
  statusBarID?: string;
  secondaryStatusID?: string;
};
type updateStatusParams = {
  isRunning?: boolean;
  isComplete?: boolean;
  isPendingPayment?: boolean;
  isAttempted?: boolean;
  isError?: boolean;
  isVisible?: boolean | null;
};

interface StatusBarSliceType {
  statusBarType: statusBarType | null;
  secondaryStatusID: string | null;

  statusBarID: string | null;

  statusBarHeight: number;
  setStatusBarHeight: (height: number) => void;

  setStatusConfig: (statusBarConfig: statusBarConfigType) => void;
  resetStatusConfig: () => void;
  resetStatusBarStore: () => void;

  updateStatues: (statusConfig: updateStatusParams) => void;
  isRunning: boolean | null;
  isComplete: boolean | null;
  isPendingPayment: boolean | null;
  isAttempted: boolean | null;
  isError: boolean | null;
  isVisible: boolean | null;
  percentageComplete: number;
  updatePercentage: (percentage: number) => void;
}
const INITIAL_STATUS = {
  isRunning: null,
  isComplete: null,
  isPendingPayment: null,
  isAttempted: null,
  isError: null,
  isVisible: null,
  percentageComplete: 0,
};
const NULL_INITIAL_STORE_VALUES = {
  statusBarID: null,
  secondaryStatusID: null,
  statusBarType: null,

  statusBarHeight: 0,
  ...INITIAL_STATUS,
};

const statusBarSlice: StateCreator<StatusBarSliceType> = (set, get) => ({
  ...NULL_INITIAL_STORE_VALUES,

  setStatusBarHeight: (height) =>
    set((state) => ({
      ...state,
      statusBarHeight: height,
    })),

  setStatusConfig: (statusBarConfig) =>
    set((state) => ({
      ...state,
      ...statusBarConfig,
    })),
  resetStatusConfig: () =>
    set((state) => ({
      ...state,
      ...INITIAL_STATUS,
    })),

  resetStatusBarStore: () =>
    set((state) => ({
      ...state,
      ...NULL_INITIAL_STORE_VALUES,
    })),

  updateStatues: (statusConfig) => {
    get();
    return set((state) => ({ ...state, ...statusConfig }));
  },

  updatePercentage: (percentage) =>
    set((state) => ({ ...state, percentageComplete: percentage })),
});

export const useStatusBarStore = create<StatusBarSliceType>(
  (set, get, api) => ({
    ...statusBarSlice(set, get, api),
  })
);
